import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';


const ImageZoomCell = ({ slide }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleimage = (value) => {
        setShow(true);
    };
    
    return (
        <>
         <div className="slick-slide"  >
             <img alt="" onClick={()=>handleimage(`${slide.image}?img=${slide.id}`)} className="slick-slide-image img-fluid" src={`${slide.image}?img=${slide.id}`} />
          </div>  
          <Modal
                size=""
                show={show}
                backdrop="static"
                keyboard={false}
                contentClassName='border-0 rounded-0'
                onHide={() => handleClose()}
                aria-labelledby=""
                >
                <Modal.Body className="p-0">
                    <div onClick={() => handleClose()} aria-label="delete" size="small" className="position-absolute top-0 end-0 btn-out">
                        <CloseIcon fontSize="small" className='text-white' />
                    </div>
                    <div>
                    <img alt="" className="slick-slide-image img-fluid" src={`${slide.image}?img=${slide.id}`} />
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ImageZoomCell